import React, { useState, useContext, useEffect } from "react";

import PAContentBlock from "../PAContentBlock";
import { Link } from "react-router-dom";
import PAInputPrices from "../PAInputPrices";
import PAwebhooks from "../PAwebhooks";
import DatePickerExample from "../DatePicker";
import SelectExample from "../SelectExample";
import SwitchExample from "../SwitchExample";
import PAInputUpgrades from "../PAInputUpgrades";

import styled, { css } from "styled-components";

import { IntlProvider } from "react-intl";
import PAh2 from '../PAh2';
import { vi } from "../../data";

import {
  FormGroup,
  Select,
  StatusDot,
  Checkbox,
  Subheader,
  Head,
  Button,
  Card,
  Input,
  RadioGroup,
  Icon,
  FormFooter,
  ButtonAction,
  Tag,
  Breadcrumbs,
  Notification,
  ContentBlock,
  Pill
} from "xsolla-uikit";

import { CssLineHover } from "./PAviGroup";
import { PAstoreGroups } from "./PAstoreGroups";




export default function PAvi({ showAsPage = false }) {
  return (
    <PAstoreGroups/>
  )

}





export  function PAvi1({ showAsPage = false }) {
  return (
    <div
    // className="xsui-width"
    >
      {/* BREADCRUMBS */}
      {showAsPage && (
        <FormGroup>
          <Breadcrumbs
            limit={6}
            items={[
              {
                label: "In-game store",
                to: "/microtransactions/"
              },
              {
                label: "Virtual items",
                to: "/microtransactions/vi"
              }
            ]}
          />
        </FormGroup>
      )}



      <FormGroup>
        {/* <ContentBlock> */}
          {/* <Head appearance="separated">
        <FormGroup>
          Search Add
        </FormGroup>
        </Head> */}

          <FormGroup>


        {/* <PAh2 title="Groups"><Button appearance="outline-secondary" size="sm">+ New group</Button></PAh2> */}



            {/* <Link to="/microtransactions/vi/group_1/"> */}
            <div className="ui-table">
              <div className="ui-table__head">
                <div
                  className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm"
                  style={{ flexShrink: 0, width: "60px" }}
                >
                  Order
                </div>
                <div
                  className="ui-table__column ui-table__column--separator ui-table__column--indentation-md"
                  style={{ maxWidth: "50%" }}
                >
                  Name
                </div>
                <div
                  className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm"
                  style={{ maxWidth: "20%" }}
                >
                  ID
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ flexShrink: 0, width: "20%" }}
                >
                  Status
                </div>
                <div
                  className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm"
                  style={{ maxWidth: "5%" }}
                />
              </div>


              <div className="ui-table__body">



                  <PAviGroupLine
                    name="All"
                    items={vi}
                  />
                  <PAviGroupLine
                    name="Weapons"
                  />


              </div>


            </div>
            {/* </Link> */}
          </FormGroup>
        {/* </ContentBlock> */}
      </FormGroup>
    </div>
  );
}





export const PAviGroupLine = ({
  order = 1,
  name = 'all',
  id = '1234',
  status = 'enabled',
  items = [0],
  active
})=> {
  return (

  <CssLineHover
    active={active}
    className="ui-table__body__row ui-table__body__row--sortable ui-table__body__row--v-align-center"
    data-id="table.rows[0]"
    // style={{color: 'red'}}
  >
    <div
      className="ui-table__column ui-table__column--indentation-sm"
      style={{ flexShrink: 0, width: "60px" }}
    >
      <div className="ui-table__drag-handle" />
      <div className="virtual-items-row__order">

        {order}

      </div>
    </div>

    <div
      className="ui-table__column ui-table__column--indentation-md"
      style={{ maxWidth: "50%" }}
    >
      <div className="virtual-items-row__name"
      // style={{color: 'red'}}
      >
        <a
          aria-current="false"
          href="/15924/projects/37471/storefront/virtual-items/groups/8593"
        >
          <img
            className="virtual-items-row__name__image"
            src="//cdn.xsolla.net/publisher-v4/folder.17729c.svg"
          />
        </a>
        <div className="virtual-items-row__name__info">
          <a
            aria-current="false"
            data-id="vi.group.name"
            href="/15924/projects/37471/storefront/virtual-items/groups/8593"
          >
            {name}

          </a>
          <div data-id="vi.group.info">Total items: {items.length} </div>
        </div>
      </div>
    </div>

    <div
      className="ui-table__column ui-table__column--indentation-sm"
      style={{ maxWidth: "20%" }}
    >
      <div className="virtual-items-row__id">{id}</div>
    </div>
    <div
      className="ui-table__column ui-table__column--indentation-sm"
      style={{ flexShrink: 0, width: "20%" }}
    >
      <div className="xsui-dropdown xsui-dropdown--autosize">

        {status === 'enabled' && <div
          className="label label--secondary label--any-pointer"
          data-id="group.status-switcher"
          data-value="enabled"
        >
          <div className="label__wrapper">
            <div className="label__child">Enabled</div>
          </div>
          <div className="label__trigger">
            <i
              className="xsui-icon xsui-icon-expand"
              style={{ fontSize: "24px", color: "inherit" }}
            />
          </div>
        </div>}



        <div />
      </div>
    </div>
    <div
      className="ui-table__column ui-table__column--indentation-sm"
      style={{ maxWidth: "5%" }}
    >
      <div className="virtual-items-row__actions">
        <div className="xsui-dropdown xsui-dropdown--autosize">
          <i
            data-id="group.options"
            className="xsui-icon xsui-icon-more xsui-icon--hoverable"
            style={{ fontSize: "24px", color: "inherit" }}
          />
          <div />
        </div>
      </div>
    </div>
  </CssLineHover>
  )
}
